module.exports = __webpack_public_path__ + "/build/web/images/hero-article@3x.c17862d3c0ef6772224bd6d0682588b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-article@3x.jpg
// module id = 138
// module chunks = 13